export default __webpack_public_path__ + "static/konnectorx-icon-e891b0aa3a9399e27db9d93b54da1a4f.png";